var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.79,
    height: 15.79,
    viewBox: "0 0 15.79 15.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.5 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.148,20.29H18.642a1.659,1.659,0,0,0,1.648-1.648V6.148A1.659,1.659,0,0,0,18.642,4.5H6.148A1.659,1.659,0,0,0,4.5,6.148V18.642A1.659,1.659,0,0,0,6.148,20.29ZM6.443,6.443H18.329v7.774L15.9,11.788a.356.356,0,0,0-.5,0l-1.8,1.787L10.5,10.469a.356.356,0,0,0-.5,0L6.443,14.026Zm6.212,2.551a1.371,1.371,0,1,1,1.371,1.371A1.363,1.363,0,0,1,12.655,8.994Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.2ce438ece9f7a7ed3329cb1537e75b01.svg";
export { ForwardRef as ReactComponent };